import React from 'react';
import { motion } from 'framer-motion';

export default function CGU() {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <section className="bg-secondary/30 py-12 sm:py-16">
        <div className="container-custom text-center px-4">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-3xl sm:text-4xl md:text-5xl font-serif mb-4"
          >
            Conditions Générales d'Utilisation
          </motion.h1>
        </div>
      </section>

      <div className="container-custom max-w-3xl px-4 py-10 sm:py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="space-y-8"
        >

          <section>
            <h2 className="text-xl sm:text-2xl font-serif mb-3">1. Mentions légales</h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN), il est porté à la connaissance des utilisateurs du site https://glowshape.fr les présentes mentions légales.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-serif mb-3">2. Éditeur du site</h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              Le site Glow Shape est édité par :<br /><br />
              Marie FLORENT<br />
              Entrepreneur individuel – Micro-entreprise<br />
              Nom commercial : Glow Shape<br />
              SIREN : 999 945 397<br />
              SIRET : 999 945 397 00027<br />
              TVA non applicable, article 293 B du CGI<br />
              Siège social : 1 rue de la Corderie, 49370 Saint-Clément-de-la-Place, France<br />
              Email : contact.glowshape49@gmail.com<br />
              Téléphone : 02 59 18 75 04
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-serif mb-3">3. Directeur de publication</h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">Marie FLORENT</p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-serif mb-3">4. Hébergement du site</h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              Le site est hébergé par :<br /><br />
              OVH SAS<br />
              2 rue Kellermann<br />
              59100 Roubaix – France<br />
              Téléphone : 1007<br />
              Site web : https://www.ovhcloud.com
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-serif mb-3">5. Propriété intellectuelle</h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              L'ensemble des contenus présents sur le site Glow Shape (textes, images, graphismes, logo, vidéos, icônes, etc.) est la propriété exclusive de Glow Shape, sauf mentions contraires explicites. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-serif mb-3">6. Responsabilité</h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              Glow Shape s'efforce de fournir des informations aussi précises que possible sur le site. Toutefois, l'éditeur ne pourra être tenu responsable des omissions, inexactitudes ou carences dans la mise à jour.
            </p>
          </section>

          <hr className="border-border" />

          <section>
            <h2 className="text-2xl sm:text-3xl font-serif mb-6">Conditions Générales d'Utilisation</h2>

            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-serif mb-2">Article 1 – Objet</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les présentes Conditions Générales d'Utilisation régissent l'accès et l'utilisation du site https://glowshape.fr
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 2 – Acceptation</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Toute navigation sur le site implique l'acceptation pleine et entière des présentes CGU.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 3 – Services proposés</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le site permet notamment :
                </p>
                <ul className="list-disc list-inside text-muted-foreground text-sm sm:text-base leading-relaxed mt-2 space-y-1">
                  <li>la consultation des prestations proposées par Glow Shape ;</li>
                  <li>la prise de rendez-vous en ligne ;</li>
                  <li>le paiement d'acomptes via Stripe ;</li>
                  <li>l'utilisation d'un formulaire de contact.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 4 – Accès au site</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le site est accessible 24h/24 et 7j/7 sauf interruption pour maintenance, mise à jour ou cas de force majeure.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 5 – Obligations de l'utilisateur</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">L'utilisateur s'engage à :</p>
                <ul className="list-disc list-inside text-muted-foreground text-sm sm:text-base leading-relaxed mt-2 space-y-1">
                  <li>utiliser le site conformément à la législation en vigueur ;</li>
                  <li>ne pas porter atteinte au bon fonctionnement du site ;</li>
                  <li>fournir des informations exactes lors des réservations.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 6 – Paiement en ligne</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les acomptes versés lors de la réservation sont sécurisés via la plateforme Stripe. Glow Shape n'a pas accès aux données bancaires complètes de l'utilisateur.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 7 – Responsabilité</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">Glow Shape ne pourra être tenue responsable :</p>
                <ul className="list-disc list-inside text-muted-foreground text-sm sm:text-base leading-relaxed mt-2 space-y-1">
                  <li>d'interruptions techniques du site ;</li>
                  <li>de bugs ou incompatibilités techniques ;</li>
                  <li>de dommages indirects liés à l'utilisation du site.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 8 – Propriété intellectuelle</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Tous les éléments du site sont protégés par le droit de la propriété intellectuelle.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 9 – Modification des CGU</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Glow Shape se réserve le droit de modifier à tout moment les présentes CGU.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">Article 10 – Droit applicable</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les présentes CGU sont régies par le droit français. Tout litige relève de la compétence des juridictions françaises compétentes.
                </p>
              </div>
            </div>
          </section>

          <hr className="border-border" />

          <section>
            <h2 className="text-2xl sm:text-3xl font-serif mb-6">Politique de confidentialité</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-serif mb-2">1. Identité du responsable du traitement</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le responsable du traitement des données est :<br />
                  FLORENT Marie / Glow Shape<br />
                  Contact : contact.glowshape49@gmail.com
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">2. Données collectées</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">Dans le cadre de l'activité, les données suivantes peuvent être collectées :</p>
                <ul className="list-disc list-inside text-muted-foreground text-sm sm:text-base leading-relaxed mt-2 space-y-1">
                  <li>Nom et prénom</li>
                  <li>Numéro de téléphone</li>
                  <li>Adresse email</li>
                  <li>Messages envoyés (Instagram, WhatsApp, SMS…)</li>
                  <li>Informations liées aux rendez-vous et prestations</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">3. Finalité de la collecte</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">Les données sont collectées pour :</p>
                <ul className="list-disc list-inside text-muted-foreground text-sm sm:text-base leading-relaxed mt-2 space-y-1">
                  <li>La gestion des rendez-vous</li>
                  <li>La communication avec les clients</li>
                  <li>La gestion des prestations et paiements</li>
                  <li>L'amélioration de l'expérience client</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">4. Base légale</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">La collecte repose sur :</p>
                <ul className="list-disc list-inside text-muted-foreground text-sm sm:text-base leading-relaxed mt-2 space-y-1">
                  <li>Le consentement du client</li>
                  <li>L'exécution d'un service (prise de rendez-vous, prestation)</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">5. Durée de conservation</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les données sont conservées pendant une durée maximale de 3 ans après le dernier contact.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">6. Partage des données</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les données ne sont jamais vendues. Elles peuvent être partagées uniquement avec des services nécessaires (ex : plateforme de paiement, réservation).
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">7. Sécurité</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les données sont protégées et accessibles uniquement par FLORENT Marie / Glow Shape.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">8. Droits des utilisateurs</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Conformément à la réglementation, chaque client peut accéder à ses données, demander leur modification ou leur suppression. Pour exercer ces droits : contact.glowshape49@gmail.com
                </p>
              </div>

              <div>
                <h3 className="text-lg font-serif mb-2">9. Mise à jour</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Cette politique peut être modifiée à tout moment.
                </p>
              </div>
            </div>
          </section>

        </motion.div>
      </div>
    </div>
  );
}
